import React, {Component} from 'react'
import {Input} from 'reactstrap'
import PropTypes from 'prop-types'
import {AvForm, AvInput} from 'availity-reactstrap-validation'
import uuid from 'uuid'

import LoadingButton from "../LoadingButton";


class ProjectInvoiceItemCreator extends Component {

    state = {
        project_activity_budget_id: '',
        description: '',
        amount: ''
    }

    reset = () => {
        this.setState({
            project_activity_budget_id: '',
            description: '',
            amount: ''
        })
    }

    render() {

        const {project_activity_budget_id, description, amount} = this.state
        const {budgets, onAdd} = this.props

        return (
            <div className="d-flex flex-row">

                <div className="d-flex mr-2 mb-0 pb-0" style={{flex: '1'}}>
                    <Input
                        size="sm"
                        type="select"
                        value={project_activity_budget_id}
                        onChange={(evt) => {
                            const record = budgets.find(budget => budget.id == evt.target.value)

                            this.setState({
                                project_activity_budget_id: record ? evt.target.value : '',
                                description: record ? record.budget_label : '',
                                amount: record ? record.amount_to_invoice : ''
                            })


                        }}
                    >
                        <option value="">---Select Activity Type---</option>
                        {budgets.map(budget => <option key={budget.id}
                                                       value={budget.id}>{budget.budget_label}</option>)}
                    </Input>
                </div>

                <div className="d-flex mr-2 mb-0 pb-0" style={{flex: '1'}}>
                    <Input
                        bsSize="sm"
                        name="description"
                        disabled={!project_activity_budget_id}
                        value={description}
                        onChange={(evt) => this.setState({description: evt.target.value})}
                    />
                </div>
                <div className="d-flex mr-2 mb-0 pb-0" style={{flex: '1'}}>
                    <Input
                        bsSize="sm"
                        type="number"
                        name="amount"
                        disabled={!project_activity_budget_id}
                        value={amount}
                        onChange={(evt) => this.setState({amount: evt.target.value})}
                    />
                </div>

                <div className="d-flex flex-row mb-0 pb-0">
                    <LoadingButton
                        icon="plus"
                        disabled={!project_activity_budget_id || !description || !amount}
                        loading={false}
                        color="success"
                        size="sm"
                        className="square-btn"
                        onClick={() => {
                            if (onAdd) onAdd({id: null, ...this.state})
                            this.reset()
                        }}
                    />
                </div>

            </div>
        )
    }

}

ProjectInvoiceItemCreator.propTypes = {
    budgets: PropTypes.array.isRequired
}

export default ProjectInvoiceItemCreator